import React from 'react';
import '../CSS/PopupModal.css';

const PopupModal = ({ onClose }) => {

    const hideForDay = () => {
        const expiry = new Date();
        expiry.setDate(expiry.getDate() + 1);
        localStorage.setItem("hidePopupUntil", expiry.toISOString());
        onClose();
    };

    return (
        <div className="popup-backdrop" onClick={onClose}>
            <div className="popup-content" onClick={e => e.stopPropagation()}>
                <button className="popup-close" onClick={onClose}>✕</button>

                <div className="popup-header">
                    <div className="popup-header-icon">🌿</div>
                    <h2 className="popup-title">이용 안내</h2>
                    <p className="popup-subtitle">워터펜션을 찾아주셔서 감사합니다</p>
                </div>

                <div className="popup-body">
                    <div className="popup-section">
                        <div className="popup-section-icon">📅</div>
                        <div className="popup-section-content">
                            <p className="popup-section-title">예약 방법</p>
                            <p>예약은 <strong>전화예약</strong>을 통해 가능합니다.</p>
                            <div className="popup-phone">
                                <span>010-2180-7979</span>
                                <span>010-7447-9222</span>
                            </div>
                            <p>예약 전 객실 정보와 요금표를 꼭 확인해주세요.</p>
                        </div>
                    </div>

                    <div className="popup-divider" />

                    <div className="popup-section">
                        <div className="popup-section-icon">💳</div>
                        <div className="popup-section-content">
                            <p className="popup-section-title">입금 안내</p>
                            <p>예약 후 <strong>2시간 이내</strong> 입금 시 예약이 확정됩니다.</p>
                            <p>입금 후 입금자 성함을 문자로 꼭 보내주셔야 예약이 완료됩니다.</p>
                            <p>입금자명이 예약자명과 다를 경우 미리 알려주세요.</p>
                            <div className="popup-account">
                                <span className="popup-account-label">농협은행</span>
                                <span className="popup-account-number">717096-52-18-6664</span>
                                <span className="popup-account-owner">예금주: 윤정아</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="popup-actions">
                    <button className="popup-btn-hide" onClick={hideForDay}>하루동안 보지 않기</button>
                    <button className="popup-btn-close" onClick={onClose}>닫기</button>
                </div>
            </div>
        </div>
    );
};

export default PopupModal;
